import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';

import { Subject } from 'rxjs';
import { LayoutsService } from '../../../../services/layouts.service';
import { CreateEditLayoutComponent } from './create-edit-layout/create-edit-layout.component';

@Component({
	selector: 'app-layouts',
	templateUrl: './layouts.component.html',
	styleUrls: ['./layouts.component.scss']
})
export class LayoutsComponent implements OnInit, OnDestroy {
	dtConfig = {
		config: {
			base: this.layoutsService,
			api: 'datatable',
			rowsPerPage: 10,
			order: [[2, 'desc']],
			params: {
				key: ''
			}
		},
		columns: [
			{
				title: 'ID',
				field: 'id'
			},
			{
				title: 'Nombre',
				field: 'name',
			}
		],
		actions: [
			{
				display: 'Editar',
				icon: 'fa-pencil',
				event: 'layouts.edit',
				conditionality: 'true'
			},
			{
				display: 'Eliminar',
				icon: 'fa-trash',
				event: 'layouts.delete',
				conditionality: 'true'
			}
		]
	};

	private atComponentDestroy = new Subject();

	constructor(
		private layoutsService: LayoutsService,
		private swal: SwalService,
		private broadcast: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private nrModal: NRModalService
	) { }

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	ngOnInit(): void {
		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				if (props) {
					this.nrModal.open(props, 'xl');
				}
			});
	}

	/**
	 * Prepare the Layouts data for the modal window
	 * @param event
	 * @returns
	 */
	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel;
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {}
		};

		switch (event.name) {
			case 'layouts.add':
				props.modalModel.component = CreateEditLayoutComponent;
				props.modalModel.modalConfiguration = {
					title: 'Agregar Layout'
				};
				break;

			case 'layouts.edit':
				props.modalModel.component = CreateEditLayoutComponent;
				props.modalModel.modalConfiguration = {
					title: 'Editar Layout'
				};
				break;
			case 'layouts.delete':
				this.delete(event.data);
				return false;
				break;
		}

		return props;
	}

	/**
	 * Open ADD modal window
	 */
	add(): void {
		this.broadcast.fire({
			name: 'layouts.add',
			type: EventType.MODAL,
			data: {}
		});
	}

	/**
	 * Get User confirmation and send the signal to the server
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: '¿Estás seguro de querer eliminar el layout?'
		};

		this.swal.warning(swalParams).then(result => {
			if (result.value) {
				this.layoutsService.delete(data.item.id).subscribe((resp: any) => {
					if (resp.success) {
						this.swal.success({ title: 'Layout eliminado exitosamente' }).then(() => {
							this.broadcast.reloadDataTable();
						});
					} else {
						this.swal.error('Ocurrio un error al intentar borrar el Layout');
					}
				});
			}
		});
	}
}
